import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from "../img/echolink-horizontal-white.png";

const Navbar = ({ isAuthenticated, onLogout }) => {
  const [userId, setUserId] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const userRole = localStorage.getItem('userRole');

  // Grab userId from localStorage
  useEffect(() => {
    const storedUserId = localStorage.getItem('userId');
    if (storedUserId) {
      setUserId(storedUserId);
    } else {
      console.error("User ID not found in localStorage");
    }
  }, []);

  const handleLogout = () => {
    onLogout();
    navigate('/');
  };

  // Helper to see if the current path includes a given substring
  const isActive = (path) => location.pathname.includes(path);

  // Parse the slug from the path (either /client/<slug> or /opt-in/<slug>)
  let slugMatch = location.pathname.match(/\/client\/([^/]+)/);
  if (!slugMatch) {
    slugMatch = location.pathname.match(/\/opt-in\/([^/]+)/);
  }
  const clientSlug = slugMatch ? slugMatch[1] : null;

  // Determine if we’re on a feedback or opt-in page
  const isOnFeedbackPage = location.pathname.includes('feedbacks');
  const isClientEditPage = location.pathname.includes('client');
  const isOnOptInPage = location.pathname.includes('optin');

  return (
    isAuthenticated && userId && (
      <nav className="navbar">
        <div className="navbar-header">
          <Link to={`/`}>
            <img src={logo} alt="logo" />
          </Link>
          <button
            className="hamburger-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            ☰
          </button>
        </div>

        <div className={`navbar-menu`}>
          <ul className="navbar-links">
            <div className='navbar-links-right'>

              {/* If we’re on the feedback page (e.g. /client/<slug>/feedbacks), show link to /client/<slug>/submit-feedback */}
              {(isOnFeedbackPage || isClientEditPage) && clientSlug && (
                <Link
                  to={`/client/${clientSlug}/submit-feedback`}
                  className="navbar-button navbar-submit-button"
                  target='_blank'
                >
                  Share Submit Feedback Page
                </Link>
              )}

              {/* If we’re on an opt-in page, show link to /opt-in/<slug> */}
              {isOnOptInPage && clientSlug && (
                <Link
                  to={`/opt-in/${clientSlug}/`}
                  className="navbar-button navbar-submit-button"
                  target='_blank'
                >
                  Share Opt-In Page
                </Link>
              )}

              {userRole === 'admin' && (
                <Link
                  to={`/admin/dashboard`}
                  className={isActive('/admin/dashboard') ? 'active-link' : ''}
                >
                  Clients
                </Link>
              )}

              <Link
                to={`/edit-account/${userRole === 'admin' ? 'user' : 'client'}/${userId}`}
                className={isActive('/edit-account') ? 'active-link' : ''}
              >
                Account
              </Link>
            </div>
            <div className="navbar-account">
              <button className="logout-button" onClick={handleLogout}>Logout</button>
            </div>
          </ul>
        </div>

        {/* Mobile menu */}
        <div className={`hamburger-contents ${menuOpen ? 'open' : ''}`}>
          <button
            className="hamburger-menu"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            close menu
          </button>
          <ul className="navbar-links">
            <div className='navbar-links-right'>

              {(isOnFeedbackPage || isClientEditPage) && clientSlug && (
                <Link
                  to={`/client/${clientSlug}/submit-feedback`}
                  className="navbar-button navbar-submit-button"
                  target='_blank'
                >
                  Share Submit Feedback Page
                </Link>
              )}

              {isOnOptInPage && clientSlug && (
                <Link
                  to={`/opt-in/${clientSlug}/`}
                  className="navbar-button navbar-submit-button"
                  target='_blank'
                >
                  Share Opt-In Page
                </Link>
              )}

              {userRole === 'admin' && (
                <Link
                  to={`/admin/dashboard`}
                  className={isActive('/admin/dashboard') ? 'active-link' : ''}
                >
                  Clients
                </Link>
              )}

              <Link
                to={`/edit-account/${userRole === 'admin' ? 'user' : 'client'}/${userId}`}
                className={isActive('/edit-account') ? 'active-link' : ''}
              >
                Account
              </Link>
            </div>
            <div className="navbar-account">
              <button className="logout-button" onClick={handleLogout}>Logout</button>
            </div>
          </ul>
        </div>
      </nav>
    )
  );
};

export default Navbar;
